/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
export class Online {
  user_ip: string = null;
  secure_status: boolean = false;
  connection_status: boolean = false;
}